import { IpdObject } from '../../entities/IpdObject'
import { apiRequest } from '../client'

export interface FetchIpdObjectsPayload {
  livingComplexId: string
  name?: string
}

export interface RawIpdObject {
  guid: string
  id: number
  name: string
}

interface IpdObjectsResponse {
  objects: RawIpdObject[]
}

export const fetchIpdObjects = async (
  payload: FetchIpdObjectsPayload
): Promise<IpdObject[]> => {
  const params = new URLSearchParams({
    livingComplexId: payload.livingComplexId
  })

  const trimmedName = payload.name?.trim()
  if (trimmedName) {
    params.set('name', trimmedName)
  }

  const response = await apiRequest(`/objects?${params.toString()}`, {
    method: 'GET'
  })

  if (response.status === 400) {
    throw new Error('Некоректные параметры запроса')
  }

  if (response.status === 404) {
    throw new Error('Объекты не найдены')
  }

  if (!response.ok) {
    throw new Error('Не удалось загрузить объекты')
  }

  const data = (await response.json()) as IpdObjectsResponse

  return data.objects?.map(item => ({
    guid: item.guid,
    id: String(item.id),
    name: item.name
  }))
}
